import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const FunctionComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { x1 = 100, y1 = 150, x2 = 300, y2 = 150, lineY = 150, lineColor = "red", pointColor = "blue", strokeWidth = 2 } = params;
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <line x1="0" y1={lineY} x2={scaledWidth} y2={lineY} stroke={lineColor} strokeWidth={strokeWidth} />
      <circle cx={x1} cy={y1} r="5" fill={pointColor} />
      <circle cx={x2} cy={y2} r="5" fill={pointColor} />
      
      {showCoords && (
        <>
          <DraggablePoint 
            cx={x1} cy={y1} 
            label="Root1" coords={`(${x1},${y1})`}
            onDrag={(x, y) => onPointDrag('x1', x, 'y1', y)}
            svgRef={svgRef}
          />
          <DraggablePoint 
            cx={x2} cy={y2} 
            label="Root2" coords={`(${x2},${y2})`}
            onDrag={(x, y) => onPointDrag('x2', x, 'y2', y)}
            svgRef={svgRef}
          />
        </>
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

